/* Warm sand drifts continue into the footer. A soft alpha shoreline avoids
   a clipped-paper edge. This layer only redraws on lighting/size changes. */
(() => {
  'use strict';
  if (window.CgauCoastalShore) {window.CgauCoastalShore.scan(document);return;}
  const instances = new Map();
  const start = scope => scope.querySelectorAll('[data-coastal-section]').forEach(section => {
    if (instances.has(section)) return;
    const scene = section.querySelector('.coast-scene');
    const footer = document.querySelector('[data-coastal-footer]') || document.querySelector('.page-wrapper > footer');
    if (!scene || !footer) return;
    const day = scene.querySelector('[data-coast-image]');
    const nightImage = scene.querySelector('[data-coast-night-image]');
    const canvas = document.createElement('canvas');
    canvas.className = 'cgau-coastal-shore'; canvas.setAttribute('aria-hidden','true');
    const ctx = canvas.getContext('2d',{willReadFrequently:true});
    if (!ctx) return;
    footer.classList.add('cgau-coastal-footer'); footer.append(canvas);
    let width = 0, height = 94, night = Number(scene.dataset.night) || 0, lastNight = -1, pending = 0, draws = 0;
    let flash = 0;
    let visible = false, suspended = false, destroyed = false, ambientPaused = section.dataset.cgauMotionPaused === 'true';
    const cleanups = [];
    const listen = (target,type,handler) => {target?.addEventListener(type,handler);cleanups.push(()=>target?.removeEventListener(type,handler));};
    const blocked = () => destroyed || suspended || document.hidden || ambientPaused || !visible;
    const fallbackLight = () => {
      if (!blocked()) canvas.style.setProperty('--coast-fallback-flash',scene.dataset.renderer==='fallback'?flash.toFixed(3):'0');
    };
    const smooth = x => {const t=Math.max(0,Math.min(1,x));return t*t*(3-2*t);};
    const random = n => {const v=Math.sin(n*127.1+311.7)*43758.5453;return v-Math.floor(v);};
    // Broad asymmetric deposits, with no sub-pixel repeating zigzag.
    const edge = x => 44 + 20*Math.sin(x/207+.35) + 10*Math.sin(x/101+1.1)
      + 3.2*Math.sin(x/47+.5);
    function photograph(img, alpha) {
      if (!img?.complete || !img.naturalWidth || alpha <= 0) return;
      const rect = scene.getBoundingClientRect();
      const scale = Math.max(rect.width / img.naturalWidth, rect.height / img.naturalHeight);
      const iw = img.naturalWidth * scale, ih = img.naturalHeight * scale;
      const x = (width-iw)/2, y = (rect.height-ih)/2 - rect.height + 12;
      ctx.globalAlpha = alpha;
      ctx.drawImage(img,x,y,iw,ih);
      // Reflect the final sand strip when the photograph ends. Continuity is
      // exact at the join, so a straight section boundary cannot appear.
      ctx.save(); ctx.translate(x,y+2*ih); ctx.scale(1,-1); ctx.drawImage(img,0,0,iw,ih); ctx.restore();
      ctx.globalAlpha = 1;
    }
    function draw() {
      pending = 0;
      if (blocked()) return;
      fallbackLight();
      const rect = footer.getBoundingClientRect();
      if (!rect.width) return;
      const dpr = Math.min(devicePixelRatio || 1,1.5);
      width = rect.width;
      const targetW = Math.round(width*dpr), targetH = Math.round(height*dpr);
      if (canvas.width !== targetW || canvas.height !== targetH) {canvas.width=targetW;canvas.height=targetH;}
      ctx.setTransform(dpr,0,0,dpr,0,0); ctx.clearRect(0,0,width,height);
      photograph(day,1);photograph(nightImage,night);
      const pixels=ctx.getImageData(0,0,targetW,targetH), rgba=pixels.data;
      // The still-image fallback remains an exact continuation of its source.
      const sandMix=scene.dataset.renderer==='webgl' ? .9*(1-night*.75) : 0;
      const exposureFlash=scene.dataset.renderer==='webgl' ? flash : 0;
      const gains=[1.04,1.20,1.06], lifts=[.08*255,.065*255,0];
      const boundaries=Array.from({length:targetW},(_,px)=>edge(px/dpr));
      const flashFill=[.11*255,.14*255,.20*255];
      const colourMap=gains.map((gain,channel)=>Array.from({length:256},(_,base)=>
        Math.min(255,(base+(base*(gain-1)+lifts[channel])*sandMix)*(1+exposureFlash*1.8)+flashFill[channel]*exposureFlash)));
      for(let py=0;py<targetH;py++) {
        const y=py/dpr;
        for(let px=0;px<targetW;px++) {
          const at=(py*targetW+px)*4;
          const feather=1-smooth((y-boundaries[px]+1.8)/4.3);
          for(let channel=0;channel<3;channel++) {
            rgba[at+channel]=colourMap[channel][rgba[at+channel]];
          }
          rgba[at+3]*=feather;
        }
      }
      ctx.putImageData(pixels,0,0);
      // Loose grains taper out in irregular little wind deposits, not a border.
      for(let i=0;i<Math.ceil(width*.42);i++) {
        const x=random(i+2)*width, r=random(i+812);
        const y=edge(x)+1+Math.pow(r,2.7)*13;
        if(random(i+71)>.52+.30*Math.sin(x/67+1.2))continue;
        const radius=.22+random(i+231)*.43;
        const shade=192-night*105+random(i+501)*24;
        ctx.fillStyle=`rgba(${shade+25},${shade+6},${shade*.66},${.12+(1-r)*.25})`;
        ctx.beginPath();ctx.arc(x,y,radius,0,Math.PI*2);ctx.fill();
      }
      lastNight=night;canvas.dataset.shoreNight=night.toFixed(3);canvas.dataset.shoreReady=String(Boolean(day?.naturalWidth));canvas.dataset.shoreFrames=String(++draws);
    }
    const schedule = () => {if (!pending && !blocked()) pending=requestAnimationFrame(draw);};
    const sync = () => {
      canvas.dataset.shoreMotion = destroyed ? 'destroyed' : suspended || document.hidden ? 'hidden' : ambientPaused ? 'ambient-paused' : !visible ? 'offscreen' : 'ready';
      if (blocked()) {cancelAnimationFrame(pending);pending=0;}
      else schedule();
    };
    const time = event => {night=event.detail?.night ?? night;if(Math.abs(night-lastNight)>.004)schedule();};
    listen(scene,'coast:time',time);listen(scene,'coast:motion',schedule);listen(day,'load',schedule);listen(nightImage,'load',schedule);
    listen(scene,'coast:weather',event=>{const next=Math.max(0,Math.min(1,Number(event.detail?.flash)||0));if(next!==flash){flash=next;if(scene.dataset.renderer==='fallback')fallbackLight();else schedule();}});
    listen(document,'visibilitychange',sync);
    listen(window,'pagehide',()=>{suspended=true;sync();});
    listen(window,'pageshow',()=>{suspended=false;sync();});
    const ambient = event => {if(typeof event.detail?.paused === 'boolean')ambientPaused=event.detail.paused;sync();};
    listen(section,'cgau:ambient-motion-change',ambient);
    listen(window,'cgau:ambient-motion-change',event=>{if(event.target===window)ambient(event);});
    const bounds = canvas.getBoundingClientRect();
    visible = bounds.bottom>0 && bounds.top<innerHeight;
    const io = new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;sync();},{threshold:0});
    io.observe(canvas);
    const ro = new ResizeObserver(schedule);ro.observe(scene);ro.observe(footer);
    instances.set(section,() => {destroyed=true;cancelAnimationFrame(pending);io.disconnect();ro.disconnect();cleanups.forEach(remove=>remove());canvas.remove();if(!footer.querySelector('canvas.cgau-coastal-shore'))footer.classList.remove('cgau-coastal-footer');});
    sync();
  });
  window.CgauCoastalShore = {scan:start};
  start(document);
  document.addEventListener('shopify:section:load',()=>start(document));
  document.addEventListener('shopify:section:unload',event=>{for(const [section,dispose] of instances)if(event.target.contains(section)){dispose();instances.delete(section);}});
})();
